import firebaseCallable from '../firebaseCallable';

const releaseTransaction = (params) => firebaseCallable('billing-releaseTransaction', params);

export default releaseTransaction;
